export const TRANSITION_STATUS_READY = 'TRANSITION_STATUS_READY';
export const TRANSITION_STATUS_PRE_TRANSITION = 'TRANSITION_STATUS_PRE_TRANSITION';
export const TRANSITION_STATUS_TRANSITIONING = 'TRANSITION_STATUS_TRANSITIONING';

export const isTransitioning = transitionStatus => (
  transitionStatus === TRANSITION_STATUS_PRE_TRANSITION ||
  transitionStatus === TRANSITION_STATUS_TRANSITIONING
);
